export default __webpack_public_path__ + "locales/cs/ArchiveDialog.json?hash=fe7d63a27ce1899b4f3114852129f8ff";